
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/no-data",
      function () {
        return require("private-next-pages/no-data/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/no-data"])
      });
    }
  